import React from "react";
import cn from "classnames";

interface TextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  className?: string;
}

export const TextArea = (props: TextAreaProps) => {
  const { className, value, onChange, type, label, ...otherProps } = props;

  return (
    <textarea
      value={value}
      className={cn(
        "text-eerie-black h-auto w-full overflow-auto rounded-lg border border-[#d9d9d9] px-4 py-3 text-base font-[var(--third-family)] transition-all duration-200 outline-none",
        "hover:not-disabled:border-sonic-silver focus:not-disabled:border-sonic-silver",
        "placeholder:text-[#b3b3b3]",
        "[&::-webkit-scrollbar]:w-2",
        "[&::-webkit-scrollbar-track]:bg-transparent",
        "[&::-webkit-scrollbar-track]:m-2",
        "[&::-webkit-scrollbar-thumb]:bg-[#d9d9d9]",
        "[&::-webkit-scrollbar-thumb]:rounded-[4px]",
        "hover:[&::-webkit-scrollbar-thumb]:bg-[#b3b3b3]",
        "enabled:hover:border-sonic-silver",
        "enabled:focus:border-sonic-silver",
        className,
      )}
      onChange={onChange}
      {...otherProps}
    />
  );
};
